import * as React from 'react';
import { PasswordValidator } from '../../../services/validators/PasswordValidator';
import { PasswordRequirementMessage } from './errors/PasswordRequirementMessage';
import { CheckMarkIcon, CrossMarkIcon } from '../Icons';

interface IndividualPasswordIndicatorData {
    isValid: boolean;
    className: string;
}

interface PasswordComplexityProps {
    password: string;
}

function useIndividualPasswordIndicatorIsValid(
    password: string,
    validationFunction: (password: string) => boolean
): IndividualPasswordIndicatorData {
    if (!password || password.length === 0) {
        return {
            isValid: false,
            className: ''
        };
    }
    const isValid = validationFunction(password);
    const className = isValid ? 'positive' : 'negative';
    return {
        isValid,
        className
    };
}

const PasswordHasLowerCaseAndUpperCaseIndicator = (props: PasswordComplexityProps): JSX.Element => {
    const { className, isValid } = useIndividualPasswordIndicatorIsValid(
        props.password,
        PasswordValidator.hasLowerAndUpperCase
    );
    return (
        <li className={className}>
            {
                isValid ?
                    <CheckMarkIcon width="12px" /> :
                    <CrossMarkIcon width="10px" style={{ marginRight: 12 }} />

            }
            {PasswordRequirementMessage.LowerUpperCase}
        </li>
    );
};

const PasswordHasNumberIndicator = (props: PasswordComplexityProps): JSX.Element => {
    const { className, isValid } = useIndividualPasswordIndicatorIsValid(
        props.password,
        PasswordValidator.hasNumber
    );
    return (
        <li className={className}>
            {
                isValid ?
                    <CheckMarkIcon width="12px" /> :
                    <CrossMarkIcon width="10px" style={{ marginRight: 12 }} />
            }
            {PasswordRequirementMessage.Number}

        </li>
    );
};

const PasswordIsAboveMinLengthIndicator = (props: PasswordComplexityProps): JSX.Element => {
    const { className, isValid } = useIndividualPasswordIndicatorIsValid(
        props.password,
        PasswordValidator.isAboveMinLength
    );

    return (
        <li className={className}>
            {
                isValid ?
                    <CheckMarkIcon width="12px" /> :
                    <CrossMarkIcon width="10px" style={{ marginRight: 12 }} />
            }
            {PasswordRequirementMessage.Length}
        </li>
    );
};

export const PasswordComplexityIndicator = (props: PasswordComplexityProps): JSX.Element  => {

    return (
        <ul className="requirements-password">
            <PasswordHasLowerCaseAndUpperCaseIndicator password={props.password}/>
            <PasswordHasNumberIndicator password={props.password}/>
            <PasswordIsAboveMinLengthIndicator password={props.password}/>
        </ul>
    );
};



// WEBPACK FOOTER //
// ./src/webportal/components/common/requirementManagers/PasswordComplexityIndicator.tsx